import { Injectable, inject } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_CLAIM_REPORT_DOCUMENT_ITEMS } from '../claim-report.api';
import { ClaimReportDocumentItem } from '../types/claim-report-device';

@Injectable()
export class ClaimReportDeviceRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  load(documentId: string): Promise<ClaimReportDocumentItem[]> {
    return this.dataAccess.get<ClaimReportDocumentItem[]>({
      path: SOFTLINE_API_CLAIM_REPORT_DOCUMENT_ITEMS,
      pathParams: { id: documentId },
    });
  }
}
